import {AboutContainer} from "./AboutStyle"



const About = () => {
  return (
    <>
    <AboutContainer>

     <img src="https://cdn.pixabay.com/photo/2021/04/21/01/59/chef-6195247_960_720.png" alt="" />

     <h4>Welcome to the culinary world of Chef Seckin, a master of Italian cuisine and a creative force in the kitchen. Born and raised in Naples, Italy, Chef Seckin developed a passion for cooking at a young age, inspired by the flavors and traditions of his homeland.
<br/>
<br/>

Chef Seckin is known for his innovative approach to traditional Italian dishes, using fresh, seasonal ingredients to create new and exciting flavor combinations. He has a talent for pairing unexpected ingredients and textures to create truly memorable meals.
<br/>
<br/>

Chef Seckin is dedicated to sharing his love of Italian cuisine with the world and has taught cooking classes and given demonstrations across the globe. He has also published several cookbooks, sharing his signature recipes with foodies everywhere.
<br></br>
</h4>
    </AboutContainer>
    </>
  )
}

export default About